<template>
    <div class="modal">
        <div class="modal-container">
            <div class="modal-header">
                <close-icon v-on:click="closeView"></close-icon>
                <h1>Admin Permissions</h1>
            </div>

            <div class="modal-body no-pad">
                <div class="flex h-full">
                    <div class="w-full md:w-1/2 md:pr-4">
                        <div class="permissions-body">
                            <ul class="list-unstyled">
                                <li v-for="(item, index) in defaultPermissions">
                                    <div class="checkbox">
                                        <label v-if="item.permission == 'super'">
                                            <input type="checkbox" v-model="permissions[item.permission]"
                                                   @change="toggleAllFields(permissions[item.permission])">
                                            {{ item.text }}
                                        </label>
                                        <label v-if="item.permission != 'super'">
                                            <input type="checkbox" v-model="permissions[item.permission]"
                                                   :disabled="superIsSelected">
                                            {{ item.text }}
                                        </label>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div class="flex">
                    <div class="right text-right">
                        <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>

                        <button class="btn-primary" type="button" @click="saveForm">Save</button>
                    </div>
                </div>
            </div>
            <router-view v-slot="{ Component }">
                <transition name="drop-in" mode="in-out">
                </transition>
            </router-view>
        </div>
    </div>
</template>

<script>
export default {
    name: "AdminUserPermissions",
    data() {
        return {
            permissions: {},
            defaultPermissions: [
                {permission: 'users', text: 'Manage Users'},
                {permission: 'journalists', text: 'Manage Journalists'},
                {permission: 'publications', text: 'Manage Publications'},
                {permission: 'releases', text: 'Manage Press Release'},
                {permission: 'media-requests', text: 'Manage Media Request'},
                {permission: 'professional-writing', text: 'Manage Professional Writing'},
                {permission: 'promotions', text: 'Manage Promotions'},
                {permission: 'containers', text: 'Manage Containers'},
                {permission: 'account-groups', text: 'Manage Account Groups'},
                {permission: 'events', text: 'Manage Events'},
                {permission: 'blogs', text: 'Manage Blog'},
                {permission: 'knowledgebase', text: 'Manage Knowledgebase'},
                {permission: 'faq', text: 'Manage FAQ'},
                {permission: 'super', text: 'Super User - Select to activate all permissions'},
            ],
        }
    },
    mounted() {
        this.setMetaTitle('User Permissions | JournoLink Control')
        this.loadData()
    },
    beforeDestroy() {
        //
    },
    methods: {
        loadData() {
            axios.get(route('admin.permissions', this.$route.params.userId))
                .then(response => {
                    if (Object.keys(response.data.permissions).length) {
                        this.permissions = response.data.permissions
                        if (this.superIsSelected) {
                            this.toggleAllFields(this.permissions.super)
                        }
                    }
                })
                .catch(e => {
                    console.error({e})
                })
        },
        saveForm() {
            axios.put(route('admin.permissions.update', {user: this.$route.params.userId}),
                this.permissions
            )
                .then(response => {
                    if (response.data.success === true) {
                        this.$bus.$emit('alert.success', 'Permissions have been updated')
                    } else {
                        this.$bus.$emit('alert.danger', response.data.message)
                    }
                    this.loadData()
                })
                .catch((e) => {
                    this.$bus.$emit('alert.danger', 'Permissions update failed')
                    console.error({e})
                })
        },
        /**
         * Emit the close event to the parent
         *
         * @return {void}
         */
        closeView() {
            this.setMetaTitle('View Account | JournoLink Control')
            this.$root.goBack()
        },
        /**
         * Handle an [Escape] keypress
         *
         * @return {void}
         */
        onEscapeKeypress() {
            this.closeView()
        },
        /**
         * toggle all fields based on super user
         * @param  {boolean} value
         * @return {void}
         */
        toggleAllFields(value) {
            this.defaultPermissions.forEach(defaultPermission => {
                this.permissions[defaultPermission.permission] = value
            })
        },
        /**
         * add user friendly text to for permission
         * @param  {string} permission
         * @return {string}
         */
        permissionText(permission) {
            let permissionText = this.defaultPermissions.find(item => item.permission == permission)
            return permissionText ? permissionText.text : permission
        },
    },
    computed: {
        superIsSelected() {
            if (this.permissions.super || this.permissions.super === 1) {
                return true
            } else {
                return false
            }
        }
    }
}
</script>

<style lang="less">
.permissions-body {
    flex: 1;
    padding: 15px;

    ul {
        list-style-type: none;
        margin: 0;
        padding: 0;

        li {
            padding: 5px 0;
        }
    }
}
</style>
